export default __webpack_public_path__ + "static/typhoid-4e8cb5e8944961721dfd5e3e5adc3def.png";